import { IonAvatar } from '@ionic/react';
import clsx from 'clsx';
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Conversation,
  RecipientRoleType,
} from '../../../types/Messaging/Conversation';
import images from '../../../assets/images';
import { transformToAge } from '../../../utils/helperFunction/transformDate';

type Props = Conversation & { unread_count: number } & { onClick?: () => void };
//   {
//   receiverId: string;
//   name: string;
//   role: Role;
//   image: string;
//   subject: string;
//   lastUpdate: string;
//   onClick?: () => void;

interface RoleBadgeProps {
  role: RecipientRoleType;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  return (
    <small
      className={clsx('px-1.5 py-0.5 rounded-sm w-fit font-medium capitalize', {
        'bg-red-100 text-red-800': role === 'consultant',
        'bg-blue-100 text-blue-800': role === 'admin',
        'bg-cyan-100 text-cyan-800': role === 'individual',
        'bg-purple-100 text-purple-800': role === 'store_owner',
      })}
    >
      {role == 'individual' ? 'customer' : role.split('_')[0]}
    </small>
  );
};

export default function ChatButton(props: Props) {
  return (
    <NavLink
      to={`/dashboard/chat/${props.id}`}
      onClick={props.onClick}
      className={`flex items-start gap-2 w-full p-2 rounded-md [&.active]:bg-gray-100 [&.active]:high-emphasis-text bg-gray-50 medium-emphasis-text`}
    >
      <IonAvatar className="w-fit h-fit">
        <img
          src={props?.recipient?.profile_image_url || images.placeholder}
          alt={`${props.recipient?.full_name} image`}
          className="w-10 h-10 object-cover object-center"
        />
      </IonAvatar>
      <div className="flex-1 overflow-hidden ">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <p className=" font-semibold high-emphasis-text truncate flex-1">
              {props.recipient?.full_name}
            </p>
            <span>
              {props.recipient?.role_type && (
                <RoleBadge role={props.recipient?.role_type} />
              )}
            </span>
          </div>
          <div className="flex items-center">
            <small className="font-normal flex-1 block gap-2 medium-emphasis-text truncate">
              {props.title ? `About: ${props.title}` : props.last_message?.body}
            </small>
            {props.unread_count > 0 && (
              <small className="block w-fit px-2 py-0.5 rounded-lg bg-primary text-white font-medium">
                {props.unread_count}
              </small>
            )}
          </div>
          {props?.last_message?.created_at && (
            <small className="w-fit block pt-2 ml-auto medium-emphasis-text font-medium">
              {transformToAge(props?.last_message?.created_at)}
            </small>
          )}
        </div>
      </div>
    </NavLink>
  );
}

export function ChatButtonSkeleton() {
  return (
    <div
      className={`flex items-start gap-2 w-full h-10 p-2 rounded-md bg-gray-100 animate-pulse`}
    ></div>
  );
}
